import React from 'react';

import Document, { List, ListItem, ListItemTitle, Preface } from '../Document';

const PrivacyPolicy = props => (
  <Document title="Privacy policy" {...props}>
    <Preface>
      {`
        Your privacy is important to us and we have prepared this Privacy Policy to explain to you 
        how we collect, use and share your personal information. This Privacy Policy governs the 
        Web sites operated by APUS WORLD WIDE LLC («Apus Agency»), including, without limitation, 
        the Web site currently located at apus.agency (collectively, the «Site»). By using the 
        Site, you consent to the collection and use of your personal information as outlined in 
        this Privacy Policy.  Please read this Privacy Policy carefully, and if you have any 
        questions, feel free to contact us.
      `}
    </Preface>
    <List>
      <ListItem>
        <ListItemTitle>1. Questions and Opt Out</ListItemTitle>
        <div>
          {`
          If you would like to ask questions or provide comments regarding this Privacy Policy 
          you may do so by sending us an e-mail at hi@apus.ag. We will not disclose Personal 
          Information to third parties for their direct marketing purposes without your consent. 
          Please be sure to include your full name, e-mail address and mailing address and 
          specifically state that you do not want your personal information shared with third parties 
          for their direct marketing purposes.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>2. Information You Choose To Submit</ListItemTitle>
        <div>
          {`
          We may collect and store personal information that you choose to voluntarily provide to us 
          when you contact us. We collect your name, residential or business address, e-mail address 
          and other personal information that you choose to provide (collectively, «Personal 
          Information»). The decision to provide this information is optional. We use the 
          information you provide to send you the communications that you request. We may also use 
          the information to communicate with you about other topics that we think may be of 
          interest to you. If you communicate with us through the «Brief» link on our Site, we may 
          ask you for information such as your name, email address and telephone number so we can 
          respond to your questions and comments. We may also use the information you provide so that 
          we can communication with you about topics we think may be of interest to you.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>3. Information We Automatically Collect</ListItemTitle>
        <div>
          {`
          We automatically collect certain non-personal information to help us understand how our users 
          use the Service (which we will refer to in this Privacy Policy, collectively, as «Usage Data»). 
          For example, each time you use the Site we may automatically collect the type of Web browser you use, your 
          operating system, your Internet Service Provider, your IP address, the pages you view, and the time and 
          duration of your visits to the Site. This anonymous usage information may be associated 
          with your username and account, but we do not disclose the associated information to third 
          parties. We use this information to help us understand how people use the Site, and 
          to enhance the services we offer.
          `}
        </div>
        <div>
          {`
          Cookies and Web Beacons. We use cookies (a small text file placed on your computer to 
            identify your computer and browser). We may also use Web beacons (an electronic file placed 
            on a Web site that monitors usage). We do not use cookies or Web beacons to collect 
            Personal Information. Most Web browsers are initially set up to accept cookies. You can 
            reset your Web browser to refuse all cookies or to indicate when a cookie is being sent. 
            Some of our Service Providers may use their own cookies and Web beacons in connection with 
            the services they perform on our behalf.
            `}
        </div>
        <div>
          {`
          We may work with third party advertising companies that may use information about your use 
          of the Site in order to provide information to us about how they are used and to provide 
          advertisements about goods and services that may be of interest to you, including our own 
          services, on third-party websites. From the Site, these companies may place or recognize a 
          unique cookie on your computer or use other technologies such as web beacons or pixel tags. 
          Our Privacy Policy does not cover any use of information that a third party ad serving 
          company may collect from you.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>4. Web Analytics</ListItemTitle>
        <div>
          {`
          We may also use third-party solutions to conduct web analytics, such as Google Analytics. 
          Google Analytics is a web analytics service provided by Google, Inc., which uses cookies to 
          help analyze how users use this website. The information generated by the cookie about your 
          use of this Site (such as your IP address, the URL visited, the date and time the page was 
          viewed) will be transmitted and stored by Google on servers in the United States. Google 
          will use this information to monitor your use of this Site, compiling reports on website 
          activity for website operators and providing other services related to website activity 
          and internet usage. Google may transfer this information to third parties where required 
          by law, or where such third parties process information on Google’s behalf. For more 
          information about Google’s privacy policy in respect of Google Analytics, please refer 
          to http://www.google.com/analytics/learn/privacy.html. You may opt out of Google Analytics by 
          visiting https://tools.google.com/dlpage/gaoptout?hl+en=GB.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>5. How We Use Information</ListItemTitle>
        <div>
          {`
          We may use your Personal Information to further our relationship with you and for other 
          purposes, including to: (a) send you newsletters and/or industry updates; (b) process, 
          evaluate and respond to your requests and inquiries; (c) verify your identity to ensure 
          security for the other purposes listed here; (d) operate, evaluate and improve our business 
          (including developing new services, managing our communications,  learning about our 
          visitors, analyzing our services, website and application, and facilitating the 
          functionality of our website or application); (f) perform data analyses (including 
          anonymisation of personal information); (e) enforce our Terms of Use; and (g) comply 
          with applicable legal requirements and industry standards and our policies. In addition, 
          if you have opted into receiving other communications from us, we use your Personal 
          Information for that purpose. We may use personal information for other additional 
          purposes. We will identify these additional purposes at the time of collection.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>6. How We Share Your Information</ListItemTitle>
        <div>
          {`
          Other than as set forth in this Privacy Policy, except for aggregate demographic information
           that we may share with third parties in a manner that does not link such information to 
           any individual, we will not share your Personal Information with third parties, unless 
           you have given us permission to do so.
           `}
        </div>
        <div>
          {`
            We may sometimes use other businesses («Service Providers») to perform certain services 
          for us, e.g., such as payment processing, debt collection and legal process, hosting and 
          maintenance, data storage and management services, production and fulfillment, and 
          marketing and promotions. We provide our Service Providers with the information 
          reasonably necessary for them to perform the services on our behalf. Each Service 
          Provider must agree to implement and maintain reasonable security procedures and practices 
          appropriate to the nature of the information involved in order to protect your information 
          from unauthorized access, destruction, use, modification or disclosure.
          `}
        </div>
        <div>
          {`We may disclose aggregate Usage Data in order to third parties. However, this 
          aggregate data will not involve the disclosure of Personal Information nor personally 
          identify you or any other users of the Site.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>7. Other Authorized Disclosures</ListItemTitle>
        <div>
          {`
          Notwithstanding anything in this Privacy Policy to the contrary, you understand and agree 
          that Apus Agency may access, preserve and disclose any information we have collected about 
          you or that you have submitted: (a) in response to subpoenas, court orders or legal 
          process, or to establish, protect or exercise our legal rights or defend against legal 
          claims; (b) to protect the rights and property of Apus Agency, or the public; (c) if we 
          believe it is necessary in order to investigate, prevent or take action regarding illegal 
          activities, fraud, or violations of the personal or intellectual property rights of others 
          or situations involving potential threats to the safety of any person; (d) to our corporate 
          affiliates, joint ventures or other companies 
          under common control with Apus Agency (in which case we will require such entities to honor 
          this Privacy Policy); and (e) if Apus Agency is acquired by or merged with another entity 
          or in connection with a sale of our assets.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>8. Links to Other Sites</ListItemTitle>
        <div>
          {`
          The Site may contain links to websites operated and maintained by third parties over 
          which we have no control. Privacy policies on such linked websites may be different from 
          our Privacy Policy. You access such linked websites at your own risk. We encourage you to 
          review the privacy policy of any such linked website you visit to understand that website’s 
          collection, storage and use of your information.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>9. Security</ListItemTitle>
        <div>
          {`
          The security of your Personal Information is important to us. We use standard security 
          procedures and practices appropriate to the nature of the information in an effort to 
          protect information from unauthorized access, destruction, use, modification or disclosure. 
          We also require our Service Providers to implement and maintain reasonable security 
          procedures and practices appropriate to the nature of the information we share with them. 
          No data transmission over the Internet or any wireless network can be guaranteed to be 
          100% secure. As a result, while we strive to protect Personal Information, we cannot and 
          do not guarantee or warrant the security of any information you transmit to or from the 
          Site, and you do so at your own risk.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>10. Children&apos;s Privacy Statement</ListItemTitle>
        <div>
          {`
          We do not knowingly collect personally identifiable information from children under the 
          age of 13. If we become aware that we have inadvertently received personally identifiable 
          information from a user under the age of 13, we will delete such information from our 
          records.  Because we do not knowingly collect any personally identifiable information 
          from children under the age of thirteen 13, we also do not knowingly distribute such 
          information to third parties.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>11. Data Processing in the Russian Federation</ListItemTitle>
        <div>
          {`
          Please be aware that your Personal Information and communications may be transferred to and 
          maintained on servers or databases located outside your state, province or country.  
          If you are located outside of the Russian Federation, please be advised that we process 
          and store all information in the Russian Federation. The laws in the United States may 
          not be as protective of your privacy as those in your location. By using our Site, you 
          agree that the collection, use, transfer and disclosure of your Personal Information and 
          communications will be governed by the applicable laws in the Russian Federation.
          `}
        </div>
      </ListItem>
      <ListItem>
        <ListItemTitle>12. Changes</ListItemTitle>
        <div>
          {`
          Apus Agency may, in its sole and absolute discretion, change this Privacy Policy from time 
          to time.  All changes to the Privacy Policy will be effective when posted. We encourage 
          you to check back often to review the latest version. In order to continue using the Site 
          following any changes to the Privacy Policy, you must agree to be bound by such changes. 
          If you object to any such changes, your sole recourse shall be to cease using our Site.
          `}
        </div>
      </ListItem>
    </List>
  </Document>
);

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/scenes/PrivacyPolicy/index.js